import { theme } from 'antd';

const BRAND = {
  primary: '#D3001A',
  primaryHover: '#B80017',
  primaryActive: '#A00014',
  surface: '#FFFFFF',
  surfaceMuted: '#FAFAFA',
  border: '#E8E8E8',
  text: '#1F1F1F',
  textMuted: '#6B7280',
  success: '#16A34A',
  warning: '#F59E0B',
  danger: '#DC2626',
  info: '#2563EB',
};

const FONT = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

export const antdTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: BRAND.primary,
    colorInfo: BRAND.info,
    colorSuccess: BRAND.success,
    colorWarning: BRAND.warning,
    colorError: BRAND.danger,

    colorText: BRAND.text,
    colorTextSecondary: BRAND.textMuted,
    colorBgLayout: BRAND.surfaceMuted,
    colorBorder: BRAND.border,
    colorBorderSecondary: '#F0F0F0',

    borderRadius: 10,
    borderRadiusLG: 14,
    borderRadiusSM: 6,

    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,

    fontFamily: FONT,
    fontSize: 14,
    lineHeight: 1.55,

    boxShadow:
      '0 1px 2px rgba(0,0,0,0.04), 0 1px 3px rgba(0,0,0,0.06)',
    boxShadowSecondary:
      '0 4px 12px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)',

    wireframe: false,
  },
  components: {
    Button: {
      borderRadius: 8,
      borderRadiusLG: 10,
      borderRadiusSM: 6,
      fontWeight: 600,
      controlHeight: 40,
      paddingInline: 20,
      primaryShadow: '0 1px 2px rgba(211,0,26,0.16)',
      defaultShadow: 'none',
    },
    Input: {
      borderRadius: 10,
      controlHeight: 40,
      paddingInline: 12,
      activeShadow: '0 0 0 3px rgba(211,0,26,0.10)',
    },
    InputNumber: {
      borderRadius: 10,
      controlHeight: 40,
    },
    Select: {
      borderRadius: 10,
      controlHeight: 40,
      optionSelectedBg: 'rgba(211,0,26,0.08)',
      optionSelectedColor: BRAND.primary,
    },
    DatePicker: {
      borderRadius: 10,
      controlHeight: 40,
    },
    Card: {
      borderRadiusLG: 14,
      paddingLG: 20,
      headerFontSize: 16,
      headerFontSizeSM: 14,
    },
    Modal: {
      borderRadiusLG: 16,
      paddingContentHorizontalLG: 24,
      titleFontSize: 18,
    },
    Table: {
      headerBg: '#F9FAFB',
      headerColor: '#6B7280',
      headerSplitColor: 'transparent',
      headerBorderRadius: 12,
      borderColor: '#F1F2F4',
      rowHoverBg: '#FBFBFC',
      cellPaddingBlock: 16,
      cellPaddingInline: 20,
      cellFontSize: 14,
      headerSortHoverBg: '#F3F4F6',
      headerSortActiveBg: '#F3F4F6',
      footerBg: '#FAFAFA',
      bodySortBg: 'transparent',
    },
    Tabs: {
      itemSelectedColor: BRAND.primary,
      itemHoverColor: BRAND.primaryHover,
      inkBarColor: BRAND.primary,
      titleFontSize: 14,
      horizontalItemPadding: '12px 0',
      horizontalItemGutter: 28,
    },
    Tag: {
      borderRadiusSM: 999,
      defaultBg: '#F4F4F5',
      defaultColor: '#3F3F46',
    },
    Tooltip: {
      borderRadius: 8,
      colorBgSpotlight: '#1F1F1F',
    },
    Drawer: {
      paddingLG: 20,
    },
    Notification: {
      borderRadiusLG: 12,
    },
    Pagination: {
      itemActiveBg: BRAND.primary,
      itemActiveColorDisabled: '#fff',
    },
    Form: {
      labelFontSize: 13,
      labelColor: '#374151',
      itemMarginBottom: 18,
      verticalLabelPadding: '0 0 6px',
    },
    Breadcrumb: {
      lastItemColor: BRAND.text,
      itemColor: BRAND.textMuted,
    },
  },
};

export default antdTheme;
